export const BILLING_SEARCH_PLACEHOLDER = 'ZM name, HR ID or mobile';
export const DEFAULT_BILLING_PAGE_SIZE = 50;

export const BILLING_ENTRY_TABS = [
  { id: 'dcr', label: 'DCR Fares' },
  { id: 'der', label: 'DER Expenses' },
] as const;

export type BillingEntryTab = (typeof BILLING_ENTRY_TABS)[number]['id'];

export const BILLING_ENTRY_TABS_LABEL = 'Entry type';

export const VERIFY_STATUS = {
  PENDING: 0,
  VERIFIED: 1,
  REJECTED: 2,
} as const;

export const WORK_TYPE_OPTIONS = [
  { id: 1, name: 'SD - Specimen Distribution' },
  { id: 2, name: 'MP - Marketing Promotion' },
  { id: 3, name: 'TC - Teacher Contact' },
  { id: 4, name: 'LC - Library Contact' },
  { id: 5, name: 'OW - Official Work' },
  { id: 6, name: 'CSR - Specimen' },
] as const;

export const APPROVE_STATUS_OPTIONS = [
  { id: VERIFY_STATUS.PENDING, name: 'Pending' },
  { id: VERIFY_STATUS.VERIFIED, name: 'Approved' },
  { id: VERIFY_STATUS.REJECTED, name: 'Rejected' },
] as const;

export const MAX_WEB_EXPENSE_LINES = 50;

export const QUEUE_DECISION_COLUMN_ID = 'status';

export const QUEUE_FIT_CONTENT_COLUMN_IDS = [QUEUE_DECISION_COLUMN_ID] as const;
